import { Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CategoryFilter from '../components/filters/category-filter';
import CategoriesTable from '../components/tables/categories-table';

const CategoriesListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()


  return (<>
    <PageHeader
      title="دسته ها"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/categories-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <CategoryFilter onFinish={setFitlers} />
    <CategoriesTable filters={filters} />
  </>);
}

export default CategoriesListRoute;
